module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-nav', {
    attrs: {
      "nav-class": "purple darken-4"
    }
  }, [_c('a', {
    staticClass: "brand-logo",
    attrs: {
      "slot": "logo",
      "href": "https://pedidos.guepardos.co/"
    },
    slot: "logo"
  }, [_c('img', {
    staticClass: "responsive-img",
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "src": require("../assets/logo-nuevo.png"),
      "width": "55"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "left hide-on-small-only"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "padding-left": "75px",
      "font-size": "29px"
    },
    attrs: {
      "href": "https://pedidos.guepardos.co/"
    }
  }, [_vm._v("Guepardos")])])]), _vm._v(" "), _c('v-side-nav', {
    attrs: {
      "slot": "side-nav",
      "id": "side"
    },
    slot: "side-nav"
  })], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 card-content valign center"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": require("../assets/logo-nuevo.png"),
      "width": "300"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col s12"
  }, [_c('h1', {
    staticClass: "center-align"
  }, [_vm._v("¡El servicio que intentas rastrear no se encuentra disponible!")])]), _vm._v(" "), _c('h3', {
    staticClass: "center-align"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://pedidos.guepardos.co/"
    }
  }, [_vm._v("Ir a Guepardos.co")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-930e0534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 348
// module chunks = 1